import { YayoyakiForm } from '@taxdown/kami-sama/dist/kamiSama/definition';

export type SummaryCardHeaderProps = {
  header?: string;
  subheader?: string | YayoyakiForm[];
  additionalIcon?: string | null;
  handleOnEdit: (e: Event) => void;
};

export const defaultProps = {
  additionalIcon: null,
  header: '',
  subheader: '',
};
